import React from 'react';
import { FormattedMessage as OriginalFormattedMessage } from 'react-intl';

const FormattedMessage = ({ id, defaultMessage, ...rest }) => {
  if (!id) {
    return <>{defaultMessage ?? ' '}</>;
  }

  return (
    <OriginalFormattedMessage id={id} defaultMessage={defaultMessage} {...rest} />
  );
};

export { FormattedMessage };
export default FormattedMessage;
